import { useContext, useEffect, useState } from 'react';

import { try_get_querystring_value } from '../../querystring';
import { API_URL } from '../../config';

import { PageLayout } from '../../components/page-layout';
import { LoadingContainer } from '../../components/loading-container';
import { InputBox } from '../../components/input-box';
import { ErrorMessage } from '../../components/error-message';

import {
    ENTER_YOUR_EMAIL,
    FAILED_TO_SEND_SMS_CODE,
    WELCOME_DESCRIPTION,
    WELCOME_TEXT,
} from '../../translator/phrase-keys';
import { LanguageContext } from '../../components/language-settings';

export function IdentityView({changeView}) {
    const [upn, setUpn] = useState("");
    const [upnValid, setUpnValid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const {translator} = useContext(LanguageContext);

    useEffect(() => {
        const [foundUpn, upnFromQueryString] = try_get_querystring_value("upn");
        if (!foundUpn) {
            return;
        }

        const valid = validateUpn(upnFromQueryString);

        setUpn(upnFromQueryString);
        setUpnValid(valid);

        if (valid) {
            verifyUpnAndSendSmsCode(upnFromQueryString);
        }
    }, []);

    function updateUpn(value) {
        const valid = validateUpn(value);
        setUpn(value);
        setUpnValid(valid);
    }

    function validateUpn(value) {
        value = value.trim();

        if (!value)
            return false;

        const email_pattern = /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/gi;
        if (!email_pattern.test(value))
            return false;

        return true;
    }

    async function verifyUpnAndSendSmsCode(upnToSend) {
        setLoading(true);

        const [loaded, id, expires, sendError] = await sendSmsCode(upnToSend);
        if (!loaded) {
            setLoading(false);
            setError(sendError);
            return;
        }

        sessionStorage.setItem("id", id);
        sessionStorage.setItem("expires", expires);

        changeView("verify");
    }

    return (
        <PageLayout
            image="svg/identity.svg"
            progress="1"
            title={translator.translate(WELCOME_TEXT)}
            description={translator.translate(WELCOME_DESCRIPTION)}>
            <LoadingContainer loading={loading}>
                <InputBox
                    value={upn}
                    onValueChange={value => updateUpn(value)}
                    onButtonClicked={() => verifyUpnAndSendSmsCode(upn)}
                    placeholder={translator.translate(ENTER_YOUR_EMAIL)}
                    focusOnInit="true"
                    disabled={!upnValid}
                />
                {error && <ErrorMessage text={translator.translate(error)} /> }
            </LoadingContainer>
        </PageLayout>
    );
}

async function sendSmsCode(upn) {
    try {
        const response = await fetch(`${API_URL}/api/reset/send-code`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                upn: upn.trim(),
            }),
        });

        if (!response.ok) {
            if (response.status === 400) {
                const error_message = await response.text();
                return [false, null, null, error_message];
            }

            if (response.status === 429) {
                const error_message = await response.text();
                return [false, null, null, error_message];
            }

            return [false, null, null, FAILED_TO_SEND_SMS_CODE];
        }

        const body = await response.json();

        return [true, body.id, Date.now() + body.expires, null];
    }
    catch {
        return [false, null, null, FAILED_TO_SEND_SMS_CODE];
    }
}